import { useEffect, useState, RefObject } from 'react';

export const useScrollProgress = (ref: RefObject<HTMLElement>) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const handleScroll = () => {
      const rect = element.getBoundingClientRect();
      const elementHeight = element.offsetHeight;
      const viewportHeight = window.innerHeight;
      
      // Calculate how far through the element we've scrolled (0 to 1)
      const scrollStart = rect.top;
      const scrollEnd = rect.bottom - viewportHeight;
      
      if (scrollStart > 0) {
        setProgress(0);
      } else if (scrollEnd < 0) {
        setProgress(1);
      } else {
        const totalScroll = elementHeight + viewportHeight;
        const currentScroll = viewportHeight - scrollStart;
        setProgress(Math.max(0, Math.min(1, currentScroll / totalScroll)));
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [ref]);

  return progress;
};
